import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts} from "components";

import UserRoles from "constants/UserRoles";
import {Button} from "reactstrap";

const breadcrumbsStatic = [{
	name: 'Hiring',
	url: '/hiring/heatmap',
	icon: 'ticket',
}];

class Heatmap extends Framework.Components.View {
	constructor(props) {
		super(props);
	}
	render() {
		let {history,roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Heatmap",
				url: `/hiring/heatmap`,
				icon: 'laptop',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>
				<Parts.Tickers.HiringTicker/>

				<Objects.HiringHeatmap
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					roles={roles}
				/>
			</div>
		);
	}
}
export default Framework.Components.withRootState(Heatmap)
